import { render, staticRenderFns } from "./ServicesDetailedView.vue?vue&type=template&id=85303012&scoped=true"
import script from "./ServicesDetailedView.vue?vue&type=script&lang=js"
export * from "./ServicesDetailedView.vue?vue&type=script&lang=js"
import style0 from "./ServicesDetailedView.vue?vue&type=style&index=0&id=85303012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85303012",
  null
  
)

export default component.exports